import { DialogDrawer } from "components/Drawer";
import useLabels from "hooks/useLabels";
import { useEffect, useState } from "react";
import { Filter, Filters } from "store/slices/search";
import ApplyAndResendFooter from "./components/ApplyAndResendFooter";
import ApplyFooter from "./components/ApplyFooter";
import FiltersForm from "./components/FiltersForm";
import useFilterDrawer from "./hooks/useFilterDrawer";
import useFilters from "./hooks/useFilters";
import { areFiltersEqual, countFilters } from "./utils/filters";

function FilterDrawer() {
  const { isFilterDrawerOpen, closeFilterDrawer, interaction, threadId } =
    useFilterDrawer();
  const [filterLabels] = useLabels("filter");

  const {
    appliedFilters: globalFilters,
    removeAllFilters: removeAllGlobalFilters,
    changeFilter,
  } = useFilters();

  const appliedFilters = interaction?.results?.filters ?? globalFilters;

  const isInteractionFilters = !!interaction && threadId;

  const [pendingFilters, setPendingFilters] = useState<Filters>(appliedFilters);
  const pendingFilterCount = countFilters(pendingFilters);

  useEffect(() => {
    setPendingFilters(appliedFilters);
  }, [appliedFilters, isFilterDrawerOpen]);

  const areFiltersChanged = !areFiltersEqual(appliedFilters, pendingFilters);

  const handleFilterChange = <T extends Filter>(
    filter: T,
    value: Filters[T]
  ) => {
    if (isInteractionFilters) {
      setPendingFilters((prev) => ({ ...prev, [filter]: value }));
    } else {
      changeFilter(filter, value);
    }
  };

  const handleRemoveAllFitlers = () => {
    removeAllGlobalFilters();
  };

  const handleClearAllPendingFilters = () => {
    setPendingFilters({});
  };

  const pendingFiltersCount = countFilters(appliedFilters);

  return (
    <DialogDrawer
      open={isFilterDrawerOpen}
      onClose={() => closeFilterDrawer()}
      headerContent={{
        title: filterLabels["title"],
      }}
      overlay={true}
      fullHeight={true}
      hideScrollBar={true}
      footer={
        isInteractionFilters ? (
          <ApplyAndResendFooter
            areFiltersChanged={areFiltersChanged}
            interaction={interaction}
            onFilterChange={handleFilterChange}
            pendingFilterCount={pendingFilterCount}
            pendingFilters={pendingFilters}
            threadId={threadId}
            onClose={() => closeFilterDrawer()}
            onClearAllFilters={handleClearAllPendingFilters}
          />
        ) : pendingFiltersCount ? (
          <ApplyFooter
            onRemoveAllFilters={handleRemoveAllFitlers}
            onDone={() => closeFilterDrawer()}
            pendingFiltersCount={pendingFiltersCount}
          />
        ) : null
      }
    >
      <FiltersForm
        pendingFilters={isInteractionFilters ? pendingFilters : appliedFilters}
        onFilterChange={handleFilterChange}
      />
    </DialogDrawer>
  );
}

export default FilterDrawer;
